import { NgModule, Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';

@Component({
    selector: 'content-list',
    templateUrl: 'content-list.template.html',
    styleUrls: ['content-list.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentList {
    @Input() item: any;

    /**
     * ContentList component
     */
    constructor() {        
    }

    ngOnInit() {
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/content-list/content-list.component.ts